export default {
	data() {
		return {
			moduleName: 'serviceWeightCategories',
			detailPageRouteName: 'serviceWeightCategoryDetail',
			entity: {
				name: null,
				note: null,
				value: null,
				id_operator: null
			},
			updateFields: [
				'name', 'note', 'value', 'id_operator'
			],
		}
	},
	methods: {
		filterFormParams(params) {
			let allowed = {}
			this._.forOwn(params, function (value, key) {
				if (this.updateFields.includes(key)) {
					allowed[key] = value
				}
			}.bind(this))
			return allowed
		},
		resetFields() {
			this.$refs['serviceweightcategoryformref'].validateServiceWeightCategoryFormRequiredFields()
			this.$refs['serviceweightcategoryformref'].$refs['nameref'].setTouched(false)
		},
		processErrorMessage(error) {
			let errorMessage = null;
			this.$refs['serviceweightcategoryformref'].validateServiceWeightCategoryFormRequiredFields()

			this._.forEach(error['validation_errors'], function (message) {
				if (message.match("^Name \"(.+)\" is not unique\.$")) {
					errorMessage = this.$gettext('Název váhy musí být unikátní.');
					this.$refs['serviceweightcategoryformref'].$refs['nameref'].setForcedInvalid(true, this.$gettext('Název není unikátní'));
				} else if (message === "Service weight category's value must be number.") {
					errorMessage = this.$gettext('Váha musí být číslo');
					this.$refs['serviceweightcategoryformref'].$refs['valueref'].setForcedInvalid(true, this.$gettext('Váha musí být číslo'));
				} else if(message.match("^Service weight category with given value \"(.+)\" already exists.$")
					|| message.match("^Global service weight category with given value \"(.+)\" already exists.$")) {

					errorMessage = this.$gettext("Váha služby s touto váhou již existuje.");
					this.$refs['serviceweightcategoryformref'].$refs['valueref'].setForcedInvalid(true, this.$gettext("Tato váha již existuje."));
				} else if ("Value must be at least 1.") {
					errorMessage = this.$gettext("Váha musí být větší než 1.");
					this.$refs['serviceweightcategoryformref'].$refs['valueref'].setForcedInvalid(true, this.$gettext("Váha musí být větší než 1."));
				} else {
					errorMessage = message;
				}
			}.bind(this))

			return error['error_message'] = errorMessage || error['error_message'];
		},
		_processDetailErrorMessage(error) {
			let deleteError = null
			this._.forEach(error['validation_errors'], function (errorMessage) {
				deleteError = errorMessage;
			}.bind(this))

			if (deleteError) {
				error['error_message'] = deleteError
			}

			return error['error_message']
		},
		_beforeCreateEntityActions(params = null) {
			if (Number(params['id_operator']) === 0) {
				params['id_operator'] = null
			}
			return params
		},
	},
	computed: {
		operatorIdComputed: {
			get() {
				return this.entity.id_operator
			},
			set(newValue) {
				this.entity.id_operator = newValue
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/views/serviceWeightCategories/mixins/serviceWeightCategories.js